export const toSentenceCase = (phrase) => {
  const lowercasePhrase = phrase.toLowerCase();
  const words = lowercasePhrase.split(" ");
  const sentenceCaseWords = [];

  words.forEach((word) => {
    sentenceCaseWords.push(`${word.charAt(0).toLocaleUpperCase()}${word.slice(1)}`);
  });

  return sentenceCaseWords.join(" ");
};
